import Reveal from "./Reveal";
import { ANIM_ICONS } from "./ServiceIcons";
import { Sparkles } from "lucide-react";
import { useI18n } from "../../lib/i18n";

export default function Services({ services }) {
  const { t, cmsT } = useI18n();
  const visible = services.filter((s) => s.visible !== false);
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="relative py-24 md:py-32 overflow-hidden"
      style={{ backgroundColor: "#111111" }}
    >
      {/* Animated grid background */}
      <div className="absolute inset-0 bg-grid-anim opacity-[0.07] pointer-events-none" />
      {/* Top/bottom fades */}
      <div className="absolute top-0 inset-x-0 h-24 bg-gradient-to-b from-[#111] to-transparent pointer-events-none" />
      <div className="absolute bottom-0 inset-x-0 h-24 bg-gradient-to-t from-[#111] to-transparent pointer-events-none" />

      <div className="container-x relative z-10">
        <Reveal>
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-6 bg-ember" />
            <span className="text-ember uppercase text-xs tracking-[0.28em] font-body font-medium">
              {t("services.eyebrow")}
            </span>
          </div>
        </Reveal>

        <Reveal delay={60}>
          <h2 className="font-display uppercase max-w-3xl leading-[1] text-4xl md:text-5xl lg:text-6xl"
              style={{ color: "#FFFFFF" }}>
            {t("services.title")}
          </h2>
        </Reveal>

        <Reveal delay={120}>
          <p className="mt-5 max-w-2xl font-light text-base md:text-lg"
             style={{ color: "#AAAAAA" }}>
            {t("services.subtitle")}
          </p>
        </Reveal>

        <div className="mt-14 grid gap-5 grid-cols-1 sm:grid-cols-2 lg:grid-cols-5">
          {visible.map((s, i) => {
            const AnimIcon = ANIM_ICONS[s.icon];
            return (
              <Reveal key={s.id} delay={i * 80}>
                <article
                  data-testid={`service-card-${s.id}`}
                  className="group relative h-full rounded-lg p-7 transition-all duration-300 hover:-translate-y-1 overflow-hidden"
                  style={{
                    backgroundColor: "#1A1A1A",
                    border: "1px solid #2E2E2E",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "rgba(229,80,58,0.55)";
                    e.currentTarget.style.boxShadow = "0 0 40px -12px rgba(229,80,58,0.35)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "#2E2E2E";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <span className="absolute inset-x-0 top-0 h-[3px] bg-ember rounded-t-lg" />

                  {/* Mini visual layer */}
                  <div className="relative w-full h-20 mb-6 rounded-md overflow-hidden border border-[#2E2E2E] bg-[#111111] flex items-center justify-center">
                    <div className="absolute inset-0 opacity-30"
                         style={{
                           backgroundImage:
                             "linear-gradient(to right, rgba(229,80,58,0.18) 1px, transparent 1px), linear-gradient(to bottom, rgba(229,80,58,0.18) 1px, transparent 1px)",
                           backgroundSize: "14px 14px",
                         }} />
                    <div className="relative z-10 w-14 h-14 rounded-md bg-ember/10 text-ember flex items-center justify-center scale-100 group-hover:scale-110 transition-transform duration-500">
                      {AnimIcon ? <AnimIcon /> : <Sparkles size={22} />}
                    </div>
                  </div>

                  <h3 className="font-display font-bold uppercase text-2xl leading-tight"
                      style={{ color: "#FFFFFF" }}>
                    {cmsT(s.name)}
                  </h3>
                  <p className="mt-4 font-light text-sm md:text-[15px] leading-relaxed"
                     style={{ color: "#888888" }}>
                    {cmsT(s.shortDesc)}
                  </p>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
